import { useEffect, useState } from "react";
import { Link } from "react-router";
import { getIconSrc } from "@components/Icon/utils/helpers";
import { IconTypeEnum } from "@components/Icon/utils/types";
import useSendPulseGaData from "@features/pulse/hooks/useSendPulseGaData";
import { SanitizedPulseData } from "@features/pulse/utils/types";

type PulseCloseButtonProps = {
  activeArticle: number;
  sortedPulseArticles: SanitizedPulseData[];
  isDesktop: boolean;
};

/** Pulse close button displayed at the top right for mobile, top left for desktop */
const PulseCloseButton = ({
  isDesktop = false,
  activeArticle,
  sortedPulseArticles,
}: PulseCloseButtonProps): React.ReactElement => {
  const { sendCustomEvent } = useSendPulseGaData();

  const [backToBt, setBackToBt] = useState<string>("");

  useEffect(() => {
    const path = sessionStorage.getItem("pulse_back_path") || "/";
    setBackToBt(path);
  }, []);

  const handleOnClick = () => {
    const label = isDesktop
      ? `desktop::click x::${activeArticle}`
      : `mobile::click x::${activeArticle}`;

    sendCustomEvent(
      label,
      sortedPulseArticles?.[activeArticle - 1]?.title || ""
    );
  };

  return (
    <Link
      to={`${backToBt}?ref=pulse`}
      data-testid="pulse-close-button-component"
      onClick={handleOnClick}
      reloadDocument
    >
      <img
        src={getIconSrc(IconTypeEnum.closeWhite)}
        width={36}
        height={36}
        alt="close"
      />
    </Link>
  );
};

export default PulseCloseButton;
